import api from './api';
import { csvUtilitiesRoutes, GET, POST } from '../constants/api';

export const validateCsv = data =>
  api({
    method: POST,
    url: `${csvUtilitiesRoutes.VALIDATE_CSV}`,
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const convertCSv = data =>
  api({
    method: POST,
    url: `${csvUtilitiesRoutes.CONVERT_CSV}`,
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const listCsv = params =>
  api({
    method: GET,
    url: `${csvUtilitiesRoutes.LIST_CSV}`,
    params,
  });

export const downloadOriginalCsv = id =>
  api({
    method: GET,
    url: `${csvUtilitiesRoutes.DOWNLOAD_ORIGINAL(id)}`,
  });

export const downloadResultCsv = id =>
  api({
    method: GET,
    url: `${csvUtilitiesRoutes.DOWNLOAD_RESULT(id)}`,
  });
